<template>
  <div class="form-group mt-5" :class="{ hasValue: showInput || tempValue }">
    <v-autocomplete
      :items="items"
      input-class="form-control"
      :value="tempValue"
      :get-label="getLabel"
      :component-item="template"
      :auto-select-one-item="true"
      :min-len="2"
      @update-items="updateItems"
      @change="update"
      @focus="checkFocus(true)"
      @item-clicked="postIt"
      @item-selected="update"
    ></v-autocomplete>

    <input
      ref="hiddenInput"
      type="hidden"
      v-validate="config.Validation"
      :data-vv-as="config.ErrorMessage"
      :name="id"
      :value="value"
    />

    <label class="form-control-placeholder">
      {{ config.Placeholder }}
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
    </label>
    <div class="invalid-feedback" ref="error">{{ errors.first(id) }}</div>
  </div>
</template>

<script>
  import TypeAlongTemplate from '@/components/base/TypeAlongTemplate.vue';
  import axios from 'axios';
  import { mapState } from 'vuex';

  export default {
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'id', 'config'],
    data() {
      return {
        tempValue: '',
        hasFocus: false,
        showInput: false,
        items: [],
        template: TypeAlongTemplate,
      };
    },
    computed: {
      ...mapState(['profileSteps', 'steps']),
    },
    methods: {
      checkFocus(isFocus) {
        this.hasFocus = isFocus;

        if (!isFocus) {
          this.$refs.error.style.display = 'block';
        }
        if (typeof this.$refs.hiddenInput != 'undefined') {
          setTimeout(() => {
            this.$refs.hiddenInput.dispatchEvent(new Event('change'));
          }, 100);
        }
      },
      getLabel(item) {
        this.showInput = false;
        if (item) {
          this.showInput = true;
          return item.name;
        }
      },
      postIt(e) {
        this.update(e);
        this.$emit('getNewData', e);

        if (typeof this.$refs.hiddenInput != 'undefined') {
          setTimeout(() => {
            this.$refs.hiddenInput.dispatchEvent(new Event('change'));
          }, 100);
        }
      },
      setLabel(item) {
        this.tempValue = item;
      },
      setItems(json) {
        if (json) {
          this.items = json[this.config.Element];
          if (this.items.length == 1) {
            this.postIt(this.items[0]);
          }
        }
      },
      updateItems(text) {
        this.$emit('input', this.tempValue);
        let search = text;
        if (
          process.env.NODE_ENV === 'development' &&
          process.env.VUE_APP_API_MODE != 'staging'
        ) {
          search = '';
        }
        if (text != '') {
          var self = this;
          var endpoint = '/data/GetZip';
          axios.post(endpoint, { searchTerm: search }).then(
            (response) => {
              self.setItems(JSON.parse(response.data.d));
            },
            (err) => {
              throw err;
            }
          );
        }
      },
      update(e) {
        if (e) {
          this.$emit('input', e);
          this.showInput = true;
        } else {
          this.showInput = false;
          this.$emit('input', '');
        }
      },
    },
    watch: {
      value: function (e) {
        if (typeof e != 'undefined' && typeof e != 'string' && e.name) {
          // this.postIt(e)
          e.name ? (this.showInput = true) : (this.showInput = false);
          this.update(e);
          if (typeof this.$refs.hiddenInput != 'undefined') {
            setTimeout(() => {
              this.$refs.hiddenInput.dispatchEvent(new Event('change'));
            }, 100);
          }
          this.$validator.extend('isobject', {
            validate() {
              return typeof e == 'object';
            },
          });
          this.tempValue = e.name;
        }
        if (this.value && this.value.name) {
          this.setLabel(this.value);
          this.value.name ? (this.showInput = true) : (this.showInput = false);
        } else if (typeof this.value == 'string' && this.value != '') {
          var data = { name: this.value };
          this.setLabel(data);
        }
      },
    },
    created() {
      if (typeof this.value == 'object' && this.value.name) {
        this.setLabel(this.value);
        this.value.name ? (this.showInput = true) : (this.showInput = false);
      } else if (typeof this.value == 'string' && this.value != '') {
        var data = { name: this.value };
        this.setLabel(data);
      }

      let self = this;
      this.$validator.extend('isobject', {
        validate() {
          return typeof self.value == 'object';
        },
      });
    },
  };
</script>
